import React from "react";

const JavadMel = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>JavadMel</h2>
        <p>Content for JavadMel page will go here.</p>
      </div>
    </div>
  );
};

export default JavadMel;
